
import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
import { Card } from '@/components/ui/card';
import { useCustomerData } from '@/hooks/useCustomerData';

const COLORS = ['#3B82F6', '#10B981', '#F59E0B', '#EC4899', '#8B5CF6'];

const SubscriptionStatsChart: React.FC = () => {
  const { customers, isLoading, customerStats } = useCustomerData();
  
  if (isLoading) {
    return <div className="flex justify-center items-center h-80">Loading subscription data...</div>;
  }
  
  console.log("SubscriptionStatsChart - customerStats:", customerStats);
  console.log("Raw customer data sample:", customers.slice(0, 5).map(c => ({ 
    id: c.id.substring(0, 8), 
    plan: c.plan, 
    status: c.status,
  })));
  
  // Count pending users manually to verify
  const pendingCount = customers.filter(c => (!c.plan || c.plan === "pending") && c.status !== "canceled").length;
  console.log(`Manual pending count: ${pendingCount} vs stats pendingUsers: ${customerStats.pendingUsers}`);
  
  // Create data for the pie chart, making sure pending is counted correctly
  const data = [
    { name: 'Pending', value: pendingCount }, // Use manually counted value for verification
    { name: 'Monthly', value: customerStats.monthlyUsers },
    { name: 'Annual', value: customerStats.annualUsers },
    { name: 'Lifetime', value: customerStats.lifetimeUsers },
    { name: 'Cancelled', value: customerStats.cancelledUsers }
  ].filter(item => item.value > 0); // Only include segments with values greater than 0
  
  console.log("SubscriptionStatsChart data:", data);
  
  return (
    <Card className="p-4">
      <ResponsiveContainer width="100%" height={400}>
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            labelLine={false}
            outerRadius={150}
            fill="#8884d8"
            dataKey="value"
            label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip formatter={(value) => [`${value} Users`, '']} />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    </Card>
  );
};

export default SubscriptionStatsChart;
